import { LogService, GlobalService, IShift } from '@medlogic/shared/shared-interfaces';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { IActivity } from '@medlogic/shared/shared-interfaces';
import { select, Store } from '@ngrx/store';
import { IAppMedlogicFhirState, isActivityLoading } from '@medlogic/fhir';


@Component({
  selector: 'ml-ui-care-plan-activities',
  templateUrl: './ui-care-plan-activities.component.html',
  styleUrls: ['./ui-care-plan-activities.component.css']
})
export class UiCarePlanActivitiesComponent implements OnInit {

  @Input() activityModeTitle: string;
  @Input() activitiesByShift: IShift[] = null;
  @Output() activityClick = new EventEmitter<IActivity>();

  public doneLoading$ = this.store.pipe(select(isActivityLoading));

  get hasAnyActivity(): boolean {
    return !!this.activitiesByShift?.some(shift => shift.activities?.length);
  }

  constructor(
    private log: LogService,
    private store: Store<IAppMedlogicFhirState>,
    public glb: GlobalService,
  ) { }

  ngOnInit() {
  }

  onActivityClick(activity: IActivity): void {
    try {
      this.activityClick.emit(activity);
    } catch (error: any) {
      this.log.Registrar(this.constructor.name, 'onActivityClick', error.message);
    }
  }
}
